import { InfoCard } from "../common/InfoCard"
import { ManualInputRow } from "../common/ManualInputRow"
import { PropertySetSelect } from "../common/PropertySetSelect"
import { UnitProps } from "../unitTypes"

export const SplitOtherTab = (props: UnitProps) => {
  const {data, unit} = props
  const unitData = data?.vars?.UNIT || {};

  return <>
    <InfoCard title="Temperature Differences" className="mt-1">
      <ManualInputRow label="Inlet to Top" dimCode='DTEMP' data={unitData?.DT_IN_TOP} attrKey=":UNIT:DT_IN_TOP" unitId={unit.id}/>
      <ManualInputRow label="Inlet to Bottom" dimCode='DTEMP' data={unitData?.DT_IN_BOTTOM} attrKey=":UNIT:DT_IN_BOTTOM" unitId={unit.id}/>
      <ManualInputRow label="Top to Bottom" dimCode='DTEMP' data={unitData?.DT_TOP_BOTTOM} attrKey=":UNIT:DT_TOP_BOTTOM" unitId={unit.id}/>
    </InfoCard>
    <ManualInputRow label="Heat Input"  dimCode='HEATFLOW' data={unitData?.Q} attrKey=":UNIT:Q" unitId={unit.id}/>
    <InfoCard title="Pressure Drops" className="mt-1">
      <ManualInputRow label="Inlet to Top" dimCode='DPRES' data={unitData?.DP_IN_TOP} attrKey=":UNIT:DP_IN_TOP" unitId={unit.id}/>
      <ManualInputRow label="Inlet to Bottom" dimCode='DPRES' data={unitData?.DP_IN_BOTTOM} attrKey=":UNIT:DP_IN_BOTTOM" unitId={unit.id}/>
      <ManualInputRow label="Top to Bottom" dimCode='DPRES' data={unitData?.DP_TOP_BOTTOM} attrKey=":UNIT:DP_TOP_BOTTOM" unitId={unit.id}/>
    </InfoCard>
    <PropertySetSelect unitId={unit.id} value={data?.args?.tpps} />
  </>
}